
<template>
    <div class="OperateNavTable">
        <!--         <div class="l-flex o-mt" v-for="(pack,unit) in [[1,'','','','']]">
            <template v-for="(item,index) in pack">
                <div v-if="index" style="padding:0 .2rem;"></div>
                <div class="l-flex-1">
                    <div v-if="item">
                        <Group :client="client" :list="Table[index+1]" :length="5"></Group>
                    </div>
                </div>
            </template>
        </div> -->
        <group :client="client" :list="Table[1]" :length="5" />
        <BoardFast :client="client" :group="TableAll" :step="true" :default-step="0.1" />
    </div>
</template>

<script>
import CommonMix from '../common.js'
import Group from '../group.vue'
export default {
    name: 'OperateKlc2',
    mixins: [CommonMix],
    props: {
        client: {}
    },
    components: {
        Group
    }
}
</script>
